import Api from "@/api/competition/financialIndex";

const competition = {
  state: {
    // 个人参赛信息和所在队伍信息
    user: {
      emp_name: "",
      emp_id: "",
      emp_post: "",
      team_name: null,
      team_id: null,
      team_state: null
    },
    // 队长信息
    captainInfo: {},
    // 队伍信息
    teamInfo: {},
    supplementInfo: {}, // 个人参赛信息(补充信息)
    delMate: {}, // 待删除队员
    companyList: [] // 公司列表
  },
  mutations: {
    // 设置报名信息
    SET_COMPETE_USER: (state, competeUser) => {
      if (competeUser) {
        state.user = { ...competeUser };
      }
    },
    // 设置队伍信息
    SETTEAMINFO(state, teamInfo) {
      state.teamInfo = teamInfo || {};
    },
    // 设置队长信息
    SETCAPTAININFO(state, captainInfo) {
      state.captainInfo = captainInfo || {};
    },
    SETSUPPLEMENTINFO: (state, data) => {
      state.supplementInfo = { ...data };
    },
    SET_DEL_MATE: (state, mate) => {
      state.delMate = { ...mate };
    },
    // 设置公司下拉列表信息
    SETCOMPANYLIST(state, companyList) {
      state.companyList = companyList;
    }
  },
  actions: {
    // 获取报名信息
    GetCompeteUser({ commit }) {
      return new Promise((resolve, reject) => {
        Api.getCompetEmp().then(
          res => {
            let competeUser =
              res == null
                ? null
                : {
                    ...res,
                    ...res.current_team
                  };
            commit("SET_COMPETE_USER", competeUser);
            resolve(competeUser);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    // 获取当前队伍信息
    getEmpTeam({ commit }) {
      return new Promise((resolve, reject) => {
        Api.getEmpTeam().then(
          res => {
            if (res) {
              const { team_members } = res;
              team_members.forEach(item => {
                if (item.captain) {
                  commit("SETCAPTAININFO", item);
                }
              });
            }
            commit("SETTEAMINFO", res);
            resolve();
          },
          err => {
            reject(err);
          }
        );
      });
    },
    // 获取指定队伍【被邀请队伍】信息
    GetBeInviteTeam({ commit }, teamId) {
      return new Promise((resolve, reject) => {
        Api.getCompetTeam(teamId).then(
          res => {
            if (res) {
              const { team_members } = res;
              team_members.forEach(item => {
                if (item.captain) {
                  commit("SETCAPTAININFO", item);
                }
              });
            }
            commit("SETTEAMINFO", res);
            resolve(res || {});
          },
          err => {
            reject(err);
          }
        );
      });
    },
    // 获取所属公司列表
    async getCompanyList({ commit }) {
      const res = await Api.competOption();
      if (res && res.length) {
        commit("SETCOMPANYLIST", res);
      }
    },
    GetCompeteShowGuide({ commit }) {
      return new Promise((resolve, reject) => {
        Api.getShowGuideFlag().then(
          res => {
            commit("SET_SHOW_COMPETE_GUIDE", res && res.is_show == 1);
            resolve(res && res.is_show == 1);
          },
          err => {
            reject(false);
          }
        );
      });
    }
  }
};

export default competition;



// WEBPACK FOOTER //
// ./src/gtn/store/modules/financialCompetition.js